module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/control-d9dba36f5531c428ed15f1990fce88a3.svg";